import mexa from './mexa'
import diaz from './diaz'
import missTacaca from './missTacaca'
import otimoKarater from './otimoKarater'
import podeserdesligado from './podeserdesligado'
import xiaoQuan from './xiaoQuan'

const artists = [
  mexa,
  diaz,
  missTacaca,
  otimoKarater,
  podeserdesligado,
  xiaoQuan,
]

export default artists
